import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Drawer,ListItemButton, 
  IconButton,
  Popper, Paper, Button,
  Tooltip, ClickAwayListener
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import MyplansBlack from "../../assets/landing_page/new/MyPlans-Black.svg";
import UserBlack from "../../assets/landing_page/new/Users-Black.svg";
import SharePlanBlack from "../../assets/landing_page/new/SharePlan-Black.svg";
import SubscriptionBlack from "../../assets/landing_page/new/Subscription-Black.svg";
import AnalysisBlack from "../../assets/landing_page/new/Analysis-Black.svg";
import ReportsBlack from "../../assets/landing_page/new/Reports-Black.svg";
import TemplatesIcon from "../../assets/landing_page/new/Templates-Black.svg";
import VideosIcon from "../../assets/landing_page/new/Videos-Black.svg";
import Logo from "../../assets/landing_page/Planshare.png";
import Logo1 from "../../assets/landing_page/Icons/planshare-icon.png";
import LeftIcon from "../../assets/landing_page/Icons/Left.png";
import RightIcon from "../../assets/landing_page/Icons/Right.png";
import Subscription from "../../assets/planshare icons/Subscription.png"
import { setTemplateForCreate, resetPlanState } from "../../Slices/planslice";
import http from "../../utils/http-common";
import profile from "../../assets/landing_page/Icons/Profile Page.svg";
import logout from "../../assets/landing_page/Icons/Logout.svg";
import Avatar from "@mui/material/Avatar";
import { useTheme } from "@mui/material/styles";

export function ProfileTab({
  handleProfileClick,
  handleLogout,
  user_picture,
  user_name,
  user_mail,
  theme,
}) {
  return (
    <List
      component='nav'
      sx={{
        p: 0,
        "& .MuiListItemIcon-root": {
          minWidth: 32,
          color: theme.palette.grey[500],
        },
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        zIndex: 1300,
      }}>
      <ListItem
        sx={{
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}>
          <ListItemIcon>
          <Avatar
            src={user_picture || ''}
            alt={user_name}
            sx={{ 
              width: 24, 
              height: 24, 
              marginRight: 2,
              bgcolor: !user_picture ? '#E5EEFB' : 'lightblue',
              color: !user_picture ? '#474747' : 'inherit',
              fontSize: '12px',
              fontFamily: "Inter, sans-serif",
            }}
          >
            {!user_picture && user_name ? user_name.charAt(0).toUpperCase() : ''}
          </Avatar>
        </ListItemIcon>
        <ListItemText>
          {user_name}
          <br />
          {user_mail}
        </ListItemText>
      </ListItem>
      <ListItemButton
        onClick={handleProfileClick}
        sx={{
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}>
        <ListItemIcon>
          <Avatar
            src={profile}
            alt='User Profile'
            sx={{ width: 24, height: 24, marginRight: 2 }}
          />
        </ListItemIcon>
        <ListItemText primary='View Profile' />
      </ListItemButton>

      <ListItemButton onClick={handleLogout}>
        <ListItemIcon>
          <Avatar
            src={logout}
            alt='Logout'
            sx={{ width: 24, height: 24, marginRight: 2 }}
          />
        </ListItemIcon>
        <ListItemText primary='Logout' />
      </ListItemButton>
    </List>
  );
}

function Sidebar({ drawerOpen, toggleDrawer }) {
  const [activeItem, setActiveItem] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();
  useEffect(() => {
    const path = location.pathname;
    const foundItem = sidebarItems.find((item) => path.startsWith(item.path));
    if (foundItem) setActiveItem(foundItem.text);
  }, [location.pathname]);

  const [sidebarItems, setSidebarItems] = useState([]);

  const sidebarConfig = {
    "My Plan": { icon: MyplansBlack, path: "/home/myplans" },
    "Stakeholders": { icon: UserBlack, path: "/home/users" },
    "Share Plan": { icon: SharePlanBlack, path: "/home/shareplan" },
    "Schedule Analysis": { icon: AnalysisBlack, path: "/home/analysis" },
    "Reports": { icon: ReportsBlack, path: "/home/reports" },
    "Subscription": { icon: Subscription, path: "/home/subscription" },
  };

  useEffect(() => {
    const fetchSidebarItems = async () => {
      const userRole = localStorage.getItem("role");
      if (!userRole) return;

      const payload = { role: userRole };

      try {
        const response = await http.post('/master_service/role/activity/mapping', payload);

        const fetchedItems = response.data.activities
          .map(activity => {
            const metadataName = activity.metadata_name;
            if (sidebarConfig[metadataName]) {
              return {
                id: activity.id, // Include ID for sorting
                text: metadataName,
                icon: sidebarConfig[metadataName].icon,
                path: sidebarConfig[metadataName].path,
              };
            }
            return null;
          })
          .filter(item => item !== null) // Remove null values
          .sort((a, b) => a.id - b.id); // Sort by ID in ascending order

        setSidebarItems(fetchedItems);
      } catch (error) {
        console.error("Error fetching sidebar items:", error);
      }
    };

    fetchSidebarItems();
  }, []);


  const handleClick = (item, path) => {
    // Auto-expand drawer when any sidebar item is selected
    if (!drawerOpen) {
      toggleDrawer();
    }
    setOpenPopper(false);
    setActiveItem(item);
    navigate(path);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [openPopper, setOpenPopper] = useState(false);

  const handleTemplateClick = (event) => {
    // Ensure drawer is expanded when Templates is selected
    if (!drawerOpen) {
      toggleDrawer();
    }
    setActiveItem("Templates");
    navigate("/home/templates");
  };

  const handlePopperNavigation = (path) => {
    navigate(path);
    setOpenPopper(false); // Close popper after navigation
  };
  const handleClickAway = () => {
    setOpenPopper(false);
  };

  const resources = [
    { text: "Templates", icon: TemplatesIcon, path: "/home/templates" },
    { text: "Videos", icon: VideosIcon, path: "/home/videos" },
    { text: "Plan Dashboard", icon: ReportsBlack, path: "/home/planDashboard" }
  ];
  const renderMenuItems = (items) =>
    items.map(({ text, icon, path }) => (
      <Tooltip
        title={!drawerOpen ? text : ""}
        placement="right"
        arrow
        key={text}
      >
        <ListItem
          button
          onClick={(e) =>
            text === "Templates"
              ? handleTemplateClick(e)
              : handleClick(text, path)
          }
          sx={{
            paddingLeft: drawerOpen ? 2 : 1,
            paddingY: 0.5,
            marginY: 0.5,
            borderRadius: "8px",
            backgroundColor:
              activeItem === text ? "#FF2800" : "transparent", // Active background
            color: activeItem === text ? "white" : "inherit", // Active text color
            transition: "background-color 0.3s, color 0.3s",
            "&:hover": {
              backgroundColor:
                activeItem === text ? "#FF2800" : "#FFE9E5", // Hover background
              color: activeItem === text ? "white" : "inherit",
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: drawerOpen ? 40 : 24,
              color: activeItem === text ? "white" : "inherit", // Icon color
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src={icon}
              alt={text}
              style={{
                filter: activeItem === text ? "invert(1)" : "none",
                height: drawerOpen ? "24px" : "30px",
                transition: "height 0.3s ease",
              }}
            />
          </ListItemIcon>
          {drawerOpen && (
            <ListItemText
              primary={text}
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "21px",
                marginLeft: 0,
                color: activeItem === text ? "white" : "inherit", // Active text color
              }}
            />
          )}
        </ListItem>
      </Tooltip>
    ));
const [user_picture, setUserPicture] = useState(
    localStorage.getItem("user_picture")
  );
  const [user_mail, setUserMail] = useState(localStorage.getItem("email"));
  const [user_name, setUserName] = useState(localStorage.getItem("user_name"));
  const [showProfileTab, setShowProfileTab] = useState(false);
  const [profileAnchorEl, setProfileAnchorEl] = useState(null);

  // Add these handlers from Topbar
  const handleProfileClick = () => {
    navigate("/home/profile");
    setShowProfileTab(false);
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "https://planshare.ai";
  };

  const toggleProfileTab = (event) => {
    setProfileAnchorEl(event.currentTarget);
    setShowProfileTab((prev) => !prev);
  };

  const handleProfileClickAway = () => {
    setShowProfileTab(false);
  };

  // Add useEffect for user picture updates
  useEffect(() => {
    const handleUserPictureUpdate = () => {
      setUserPicture(localStorage.getItem("user_picture"));
    };

    window.addEventListener("storage", handleUserPictureUpdate);
    return () => {
      window.removeEventListener("storage", handleUserPictureUpdate);
    };
  }, []);
  
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerOpen ? 190 : 45,
        "& .MuiDrawer-paper": {
          width: drawerOpen ? 190 : 45,
          boxSizing: "border-box",
          transition: "width 0.3s ease",
          overflowX: "hidden",
          borderRight: "1px solid #dcdcdc",
        },
      }}
    >
      {/* Logo and Drawer Toggle */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: drawerOpen ? "space-between" : "center",
          p: 2,
        }}
      >
        <img
          src={drawerOpen ? Logo : Logo1}
          alt="Logo"
          style={{ height: "30px", cursor: "pointer" }}
          onClick={() => {
            navigate("/home/dashboard")
            dispatch(resetPlanState());
          }} 
        />
      </Box>
      
      {/* Sidebar Items */}
      <ClickAwayListener onClickAway={handleClickAway}>
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <List sx={{paddingTop: '0px'}}>
            {renderMenuItems(sidebarItems)}
          </List>

          {/* Drawer Toggle Button */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              flexShrink: 0
            }}
          >
            <IconButton
              onClick={() => {
                toggleDrawer(); // Toggle the drawer
                if (openPopper) setOpenPopper(false); // Close popper if open
              }}
            >
              <img
                src={drawerOpen ? LeftIcon : RightIcon}
                alt="Toggle"
                style={{ height: "30px", cursor: "pointer" }}
              />
            </IconButton>
          </Box>

          {/* Resources Section */}
          <Box sx={{ display: "flex", flexDirection: "column", height: "100%",  }}>
            {drawerOpen && (
              <Typography
                variant="h6"
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 600,
                  lineHeight: "14.52px",
                  paddingLeft: 2
                }}
              >
                Resources
              </Typography>
            )}
            <List>
              {renderMenuItems(resources)}
            </List>

            {/* Popper for Templates */}
            {openPopper && (
              <Popper
                open={openPopper}
                anchorEl={anchorEl}
                placement="right-start"
                sx={{
                  zIndex: 1200,
                  paddingLeft: drawerOpen ? "20px" : "10px",
                  marginLeft: drawerOpen ? 225 : 60,
                }}
              >
                <Paper
                  sx={{
                    padding: "5px",
                    boxShadow: 3,
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "4px",
                  }}
                >
                  <Button
                    sx={{
                      color: "black",
                      textTransform: "none",
                    }}
                    onClick={() => handlePopperNavigation("/home/templates")}
                  >
                    Search Template
                  </Button>
                  <Button
                    sx={{
                      color: "black",
                      textTransform: "none",
                    }}
                    onClick={() => {
                      handlePopperNavigation("/home/createplan")
                      dispatch(setTemplateForCreate({
                        isTemplate: true,
                        table: false,
                      }));
                    }}
                  >
                    Create Template
                  </Button>
                </Paper>
              </Popper>
            )}
          </Box>
        </Box>
      </ClickAwayListener>
      <Box sx={{ mt: "auto"}}>
          <ClickAwayListener onClickAway={handleProfileClickAway}>
            <Box>
              <Button color="inherit" onClick={toggleProfileTab} sx={{ width: "100%", justifyContent: drawerOpen ? "flex-start" : "center" }}>
                <Avatar
                  src={user_picture || ''}
                  alt={user_name}
                  sx={{ 
                    width: 24, 
                    height: 24, 
                    marginRight: drawerOpen ? 2 : 2,
                    bgcolor: !user_picture ? '#E5EEFB' : 'transparent',
                    color: !user_picture ? '#474747' : 'inherit',
                    fontSize: '12px',
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  {!user_picture && user_name ? user_name.charAt(0).toUpperCase() : ''}
                </Avatar>
                {drawerOpen && (
                  <Box
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "18px",
                      letterSpacing: "-0.005em",
                      textAlign: "left",
                    }}
                  >
                    {user_name}
                  </Box>
                )}
              </Button>
              {showProfileTab && (
                <Popper
                  open={showProfileTab}
                  anchorEl={profileAnchorEl}
                  placement="right-start"
                >
                  <ProfileTab
                    handleProfileClick={handleProfileClick}
                    handleLogout={handleLogout}
                    user_picture={user_picture}
                    user_name={user_name}
                    user_mail={user_mail}
                    theme={theme}
                  />
                </Popper>
              )}
            </Box>
          </ClickAwayListener>
        </Box>
    </Drawer>
  );
}

export default Sidebar;


export const AdminSidebar = ({ drawerOpen, toggleDrawer, sideBarDatas = [] }) => {
  const [activeItem, setActiveItem] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState(null);
  const [openPopper, setOpenPopper] = useState(false);
  useEffect(() => {
    const path = location.pathname;
    const foundItem = sidebarItems.find((item) => path == item.path);
    if (foundItem) setActiveItem(foundItem.text);
  }, [location.pathname]);

  const [sidebarItems, setSidebarItems] = useState(sideBarDatas || []);

  const handlePopperNavigation = (path) => {
    navigate(path);
    setOpenPopper(false); // Close popper after navigation
  };
  const handleClickAway1 = () => {
    setOpenPopper(false);
  };
  const handleClick = (item, path) => {
    setOpenPopper(false);
    setActiveItem(item);
    navigate(path);
  };

  const handleTemplateClick = (event) => {
    setActiveItem("Templates");
    navigate("/home/templates");
    //setAnchorEl(event.currentTarget);
    //setOpenPopper((prev) => (anchorEl === event.currentTarget ? !prev : true));
  };


  const renderMenuItems = (items) =>
    items.map(({ text, icon: IconComponent, path }) => (
      <Tooltip
        title={!drawerOpen ? text : ""}
        placement="right"
        arrow
        key={text}
      >
        <ListItem disableRipple
          button
          onClick={(e) =>
            text === "Templates"
              ? handleTemplateClick(e)
              : handleClick(text, path)
          }
          sx={{
            paddingLeft: drawerOpen ? 2 : 2,
            borderRadius: "8px",
            backgroundColor:
              activeItem === text ? "#FF2800" : "transparent", // Active background
            color: activeItem === text ? "white" : "inherit", // Active text color
            transition: "background-color 0.3s, color 0.3s",
            "&:hover": {
              backgroundColor:
                activeItem === text ? "#FF2800" : "#FFE9E5", // Hover background
              color: activeItem === text ? "white" : "inherit",
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: drawerOpen ? 25 : 20,
              color: activeItem === text ? "white" : "inherit", // Icon color
              display: "flex",
              justifyContent: "center",
              p: 0
            }}
          >

            <img
              src={IconComponent}
              alt={text}
              style={{
                filter: activeItem === text ? "invert(1)" : "none",
                height: drawerOpen ? "20px" : "20px",
                transition: "height 0.3s ease",
              }}
            />
          </ListItemIcon>
          {drawerOpen && (
            <ListItemText
              primary={text}
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "21px",
                marginLeft: 0,
                color: activeItem === text ? "white" : "inherit", // Active text color
              }}
            />
          )}
        </ListItem>
      </Tooltip>
    ));
  const [user_picture, setUserPicture] = useState(
    localStorage.getItem("user_picture")
  );
  const [user_mail, setUserMail] = useState(localStorage.getItem("email"));
  const [user_name, setUserName] = useState(localStorage.getItem("user_name"));
  const [showProfileTab, setShowProfileTab] = useState(false);
  const [profileAnchorEl, setProfileAnchorEl] = useState(null);
  const handleProfileClick = () => {
    navigate("/home/profile");
    setShowProfileTab(false); // Close the ProfileTab after navigation
  };



  const handleLogout = () => {
    localStorage.clear();
    //navigate("/");
    window.location.href = "https://planshare.ai";
    //window.location.reload();
  };

  const toggleProfileTab = (event) => {
    setProfileAnchorEl(event.currentTarget);
    setShowProfileTab((prev) => !prev);
  };

  const handleProfileClickAway = () => {
    setShowProfileTab(false);
  };

  useEffect(() => {
    const handleUserPictureUpdate = () => {
      setUserPicture(localStorage.getItem("user_picture"));
    };

    window.addEventListener("storage", handleUserPictureUpdate);

    return () => {
      window.removeEventListener("storage", handleUserPictureUpdate);
    };
  }, []);
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerOpen ? 190 : 60,
        "& .MuiDrawer-paper": {
          width: drawerOpen ? 190 : 60,
          boxSizing: "border-box",
          transition: "width 0.3s ease",
          overflowX: "hidden",
          borderRight: "1px solid #dcdcdc",
        },
      }}
    >
      {/* Logo and Drawer Toggle */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: drawerOpen ? "space-between" : "center",
          padding: 2,
        }}
      >
        <img
          src={drawerOpen ? Logo : Logo1}
          alt="Logo"
          style={{ height: "30px", cursor: "pointer" }}
          onClick={() => navigate("/admin")}
        />
      </Box>

      {/* Sidebar Items */}
      <ClickAwayListener onClickAway={handleClickAway1}>
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <List sx={{ px: '3px' }}>
            {renderMenuItems(sidebarItems)}
          </List>

          {/* Drawer Toggle Button */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              flexShrink: 1,
            }}
          >
            <IconButton
              onClick={() => {
                toggleDrawer(); // Toggle the drawer
                if (openPopper) setOpenPopper(false); // Close popper if open
              }}
            >
              <img
                src={drawerOpen ? LeftIcon : RightIcon}
                alt="Toggle"
                style={{ height: "30px", cursor: "pointer" }}
              />
            </IconButton>
          </Box>

          {/* Resources Section */}
          <Box sx={{ mt: "auto"}}>

            {/* Popper for Templates */}
            {openPopper && (
              <Popper
                open={openPopper}
                anchorEl={anchorEl}
                placement="right-start"
                sx={{
                  zIndex: 1200,
                  paddingLeft: drawerOpen ? "20px" : "10px",
                  marginLeft: drawerOpen ? 225 : 65,
                }}
              >
                <Paper
                  sx={{
                    padding: "5px",
                    boxShadow: 3,
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "4px",
                  }}
                >
                  <Button
                    sx={{
                      color: "black",
                      textTransform: "none",
                    }}
                    onClick={() => handlePopperNavigation("/home/templates")}
                  >
                    Search Template
                  </Button>
                  <Button
                    sx={{
                      color: "black",
                      textTransform: "none",
                    }}
                    onClick={() => {
                      handlePopperNavigation("/home/createplan")
                      dispatch(setTemplateForCreate({
                        isTemplate: true,
                        table: false,
                      }));
                    }}
                  >
                    Create Template
                  </Button>
                </Paper>
              </Popper>
            )}
          </Box>
        </Box>
      </ClickAwayListener>
      <Box sx={{ mt: "auto"}}>
          <ClickAwayListener onClickAway={handleProfileClickAway}>
            <Box>
              <Button color="inherit" onClick={toggleProfileTab} sx={{ width: "100%", justifyContent: drawerOpen ? "flex-start" : "center", p: 2 }}>
                <Avatar
                  src={user_picture || ''}
                  alt={user_name}
                  sx={{ 
                    width: 32, 
                    height: 32, 
                    marginRight: drawerOpen ? 2 : 0,
                    bgcolor: !user_picture ? '#E5EEFB' : 'lightblue',
                    color: !user_picture ? '#474747' : 'inherit',
                    fontSize: '12px',
                    fontFamily: "Inter, sans-serif",
                    display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
                  }}
                >
                  {!user_picture && user_name ? user_name.charAt(0).toUpperCase() : ''}
                </Avatar>
                {drawerOpen && (
                  <Box
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "18px",
                      letterSpacing: "-0.005em",
                      textAlign: "left",
                    }}
                  >
                    {user_name}
                  </Box>
                )}
              </Button>
              {showProfileTab && (
                <Popper
                  open={showProfileTab}
                  anchorEl={profileAnchorEl}
                  placement="right-start"
                >
                  <ProfileTab
                    handleProfileClick={handleProfileClick}
                    handleLogout={handleLogout}
                    user_picture={user_picture}
                    user_name={user_name}
                    user_mail={user_mail}
                    theme={theme}
                  />
                </Popper>
              )}
            </Box>
          </ClickAwayListener>
        </Box>
    </Drawer>
  );
}
